import React, { FC } from "react";
import { MediumHeader } from "@narvar/nth-bit-header";
import { useTranslations } from "@narvar/nth-hook-translations";
import displayReasons from "./displayReasons";
import { ReturnReasonsListProps } from "./types";
import LanguageKeys from "../../ReviewSummary/consts/language_en_US";
import { Language } from "../../ReviewSummary/components";
import SelectList from "../../ReviewSummary/components/SelectList/SelectList";
import { LanguageProvider } from "@narvar/nth-kit-returns-headless";
import { SelectListOption } from "../../ReviewSummary/components/types";

const tempLanguageKeys = {
  returnsReasonsListTitle: LanguageKeys.returnsReasonsListTitle,
  returnsReasonsListTitleSecondary:
    LanguageKeys.returnsReasonsListTitleSecondary,
};

const ReturnReasonsList: FC<ReturnReasonsListProps> = ({
  reasons,
  onChange,
  selection,
}) => {
  const reasonNodes: SelectListOption[] = displayReasons({
    reasons,
    selection,
  }).map(({ id, name }, i) => ({
    label: `${name || id || i}`,
    value: `${id ?? name ?? ""}`,
  }));

  const handleChange = (e: string) => {
    const selectedReason =
      reasons.find((reason) => reason.id === e) ||
      reasons.find((reason) => reason.name === e);

    if (selectedReason) {
      onChange(selectedReason);
    }
  };

  const currentSelection = reasons.find(
    (reason) => reason?.id === selection[selection.length - 1]?.id,
  );

  return (
    <>
      <MediumHeader>
        {selection.length === 0 ? (
          <Language langKey="returnsReasonsListTitle" />
        ) : (
          <Language langKey="returnsReasonsListTitleSecondary" />
        )}
      </MediumHeader>
      <SelectList
        onChange={handleChange}
        selection={currentSelection?.id}
        options={reasonNodes}
      />
    </>
  );
};

const ReturnReasonsListWrapped = (props: ReturnReasonsListProps) => {
  const { returnsReasonsListTitle, returnsReasonsListTitleSecondary } =
    useTranslations();

  const title =
    returnsReasonsListTitle ?? tempLanguageKeys.returnsReasonsListTitle;
  const secondaryTitle =
    returnsReasonsListTitleSecondary ??
    tempLanguageKeys.returnsReasonsListTitleSecondary;

  return (
    <LanguageProvider
      language={{
        returnsReasonsListTitle: title,
        returnsReasonsListTitleSecondary: secondaryTitle,
      }}>
      <ReturnReasonsList {...props} />
    </LanguageProvider>
  );
};

export default ReturnReasonsListWrapped;
